import React, { createContext, useEffect, useRef, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import CommonModal from "../CommonComponent/CommonModal/CommonModal";
import ComponentIdentifier from '../CommonComponent/ComponentHeader/ComponentIdentifier';
import HeaderComponent from '../CommonComponent/ComponentHeader/HeaderComponent';
import { useDispatch } from 'react-redux';
import { getAllMemberRequesForExportAction, getAllMemberRequestAction } from '../../Redux/Action/MemberAction';
import MemberRequestTable from './utility/MemberRequestTable';
import MemberRequestDeleteWarning from './utility/MemberRequestDeleteWarning';
import { ToastContainer } from 'react-toastify';

export const MemberRequestContext = createContext()

function MemberRequestComponent() {
    // hooks
    const dispatch = useDispatch()
    const membersExportRef = useRef()
    // states
    const [forceToFetchData, setForceToFetchData] = useState(false)
    const [dataForTable, setDataForTable] = useState({});
    const [pageConfigurationFromCommonPagination, setPageConfigurationFromCommonPagination] = useState({})
    const [searchedKey, setSearchedKey] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [getSingleMemberData, setGetSingleMemberData] = useState({});
    const [rejectModal, setRejectModal] = useState(false)
    const [searchIsDisabled, setSearchIsDisabled] = useState(false)


    // data fetch lifecycle
    useEffect(() => {
        const disableSearchField = (is_disabled) => {
            document.getElementById("searchField").disabled = is_disabled
            is_disabled == false && document.getElementById("searchField").focus()
        }

        const Payload = {
            data: {
                search_key: searchedKey,
                skip: (currentPage - 1) * 50,
                limit: 50
            },
            setDataForTable,
            pageConfigurationFromCommonPagination,
            setSearchIsDisabled,
            disableSearchField
        }

        dispatch(getAllMemberRequestAction(Payload))
    }, [forceToFetchData])

    // export on click
    const exportOnClick = () => {
        // making payload for export members
        const payload = {
            data: {},
            membersExportRef,
        };
        // action dipsatch
        dispatch(getAllMemberRequesForExportAction(payload));
    }

    return (
        <>
            <MemberRequestContext.Provider value={{
                setRejectModal,
                dataForTable,
                setGetSingleMemberData,
                setForceToFetchData,
                getSingleMemberData,
                pageConfigurationFromCommonPagination,
                setPageConfigurationFromCommonPagination,
                currentPage,
                setCurrentPage
            }}>
                <Card>
                    <Card.Header className="d-flex align-items-center justify-content-between">
                        <ComponentIdentifier link_name={"Member Request"} component_name={""} />
                        <div className="d-flex align-items-center justify-content-between">
                            {HeaderComponent.refresh([setForceToFetchData])}
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <div className='mb-2 d-flex align-items-center'>
                            <Form.Group className={"w-100"} >
                                <Form.Control
                                    id='searchField'
                                    onChange={(e) => {
                                        setSearchedKey(e.target.value)
                                    }}
                                    onKeyUp={(e) => {
                                        if (e.key === 'Enter' || e.keyCode === 13) {
                                            setForceToFetchData((prev) => !prev);
                                        }
                                    }}
                                    // id={"searchedKey"}
                                    type="text"
                                    placeholder={"Search Name / Village / Phone No."}
                                />
                            </Form.Group>
                            {/* search button */}
                            <Button disabled={searchIsDisabled} onClick={(e) => {
                                setForceToFetchData((prev) => !prev);
                            }} className='mx-2'>Search</Button>
                            {/* export button */}
                            <Button ref={membersExportRef} onClick={(e) => {
                                exportOnClick()
                            }} className='btn-success'>Export</Button>
                        </div>
                        <MemberRequestTable />
                    </Card.Body>
                </Card >

                {/*import member modal*/}
                <CommonModal
                    show={rejectModal}
                    setShow={setRejectModal}
                    title={"Reject Member"}
                    size="md"
                >
                    <MemberRequestDeleteWarning />
                </CommonModal>


                <ToastContainer />
            </MemberRequestContext.Provider>
        </>
    );
}

export default MemberRequestComponent;